<template>
  <div
    class="flex flex-1 h-full justify-start flex-col m-0 bg-neutral-100 dark:bg-slate-900 max-w-full"
  >
    <settings-header
      button-route="new"
      :icon="icon"
      :header-title="$t(headerTitle)"
      :show-count-key="showCountKey"
      :button-text="$t(headerButtonText)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      :show-new-button="showNewButton"
      :show-sidemenu-icon="showSidemenuIcon"
      :header-class="headerClass"
      :title-class="titleClass"
      :button-class="buttonClass"
      :button-icon="buttonIcon"
      :button-icon-size="buttonIconSize"
    >
      <template v-if="hintComponent" #hint>
        <component :is="hintComponent" />
      </template>
      <template #right>
        <router-view name="header" />
      </template>
    </settings-header>
    <keep-alive v-if="keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-else />
  </div>
</template>

<script>
/* eslint no-console: 0 */
import SettingsHeader from './SettingsHeader.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  components: {
    SettingsHeader,
  },
  mixins: [hasPermissionMixin],
  props: {
    headerTitle: { type: String, default: '' },
    showCountKey: { type: String, default: null },
    headerButtonText: { type: String, default: '' },
    icon: { type: String, default: '' },
    keepAlive: {
      type: Boolean,
      default: true,
    },
    newButtonRoutes: {
      type: Array,
      default: () => [],
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    showSidemenuIcon: {
      type: Boolean,
      default: true,
    },
    hintComponent: {
      type: [Object, Function],
      default: null,
    },
    headerClass: {
      type: [String, Array, Object],
      default: '',
    },
    titleClass: {
      type: [String, Array, Object],
      default: 'text-slate-900 dark:text-slate-100',
    },
    buttonClass: {
      type: [String, Array, Object],
      default: '',
    },
    buttonIcon: {
      type: String,
      default: 'add-circle',
    },
    buttonIconSize: {
      type: [String, Number],
      default: '20',
    },
  },
  data() {
    return {};
  },
  computed: {
    currentPage() {
      return this.$store.state.route.name;
    },
    showNewButton() {
      if (this.currentPage === 'settings_inbox_list') {
        return (
          this.hasCreatePermission('Inbox') &&
          this.newButtonRoutes.length !== 0 &&
          !this.showBackButton
        );
      }
      if (this.currentPage === 'online_wa_templates_list') {
        return (
          this.hasCreatePermission('WhatsApp Templates') &&
          this.newButtonRoutes.length !== 0 &&
          !this.showBackButton
        );
      }
      if (this.currentPage === 'settings_teams_list') {
        return (
          this.hasCreatePermission('Teams') &&
          this.newButtonRoutes.length !== 0 &&
          !this.showBackButton
        );
      }
      return this.newButtonRoutes.length !== 0 && !this.showBackButton;
    },
  },
};
</script>
